import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function KinDraftSummary({ groupId }) {
console.log('KinDraftSummary received groupId:', groupId);
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (groupId) {
      fetchSummary();
    }
  }, [groupId]);

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/group-orders/summary/${groupId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      const data = await res.json();
    console.log('Draft summary data:', data);
      setData(data);
    } catch (err) {
      console.error('Error fetching draft summary:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-4">Loading draft summary...</div>;
  if (error) return <div className="text-center py-4 text-red-600">Error: {error}</div>;
  if (!data) return null;

  const { drafts, summary } = data;
  const hasDrafts = drafts && drafts.length > 0;

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h3 className="text-lg font-semibold mb-4">📊 Order Summary</h3>
      
      {!hasDrafts ? (
        <p className="text-gray-500 text-sm">No draft orders yet.</p>
      ) : (
        <>
          {/* Draft List */}
          <div className="mb-4">
            <div className="space-y-2">
              {drafts.map(draft => (
                <div key={draft._id} className="flex justify-between items-center border-b pb-2 text-sm">
                  <span>{draft.sellerName}</span>
                  <span className="font-medium">${draft.totalAmount.toFixed(2)}</span>
                  <span className={`text-xs px-2 py-0.5 rounded ${draft.status === 'funded' ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}`}>
                    {draft.status}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Financial Summary */}
          <div className="border-t pt-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Total Draft Value</span>
              <span className="font-medium">${summary.totalDraftValue.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">Platform Fee (2%)</span>
              <span className="text-red-600">-${summary.platformFee.toFixed(2)}</span>
            </div>
            {summary.compensationPercentage > 0 && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Coordinator Fee ({summary.compensationPercentage}%)</span>
                <span className="text-amber-600">-${summary.coordinatorFee.toFixed(2)}</span>
              </div>
            )}
            <div className="flex justify-between text-sm font-semibold border-t pt-2">
              <span>Estimated Total Required</span>
              <span>${summary.estimatedTotal.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm font-semibold">
              <span>Available Funds</span>
              <span className="text-green-600">${summary.availableFunds.toFixed(2)}</span>
            </div>
            <div className={`flex justify-between text-sm font-bold border-t pt-2 ${summary.isDeficit ? 'text-red-600' : 'text-green-600'}`}>
              <span>{summary.isDeficit ? '⚠️ Shortfall' : '✅ Surplus'}</span>
              <span>${summary.shortfall.toFixed(2)}</span>
            </div>
          </div>

          {/* Warning Message */}
          {summary.isDeficit && (
            <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-800 font-medium text-sm">
                ⚠️ You need <strong>${summary.shortfall.toFixed(2)}</strong> more before placing orders.
              </p>
              <p className="text-red-600 text-xs mt-1">
                Request contributions from members or wait for additional funds.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
